import { useEffect } from 'react';
import Chart from 'chart.js'

const SemiDonughnutGraph = ({ completed, id='myChart', total, title = '', liner = '', color = '#2168F3', classes = '', graphClasses = '', metricValue = '', linerStyles = 'bottom-11' }) => {
  const percentage = total > 0 ? Math.round(completed / total * 100) : 0;
  const bluePercent = percentage
  const grayPercent = percentage > 100 ? 0 : 100 - percentage

  useEffect(() => {
    drawGraph()
  }, [completed, total])

  const drawGraph = () => {
    var ctx = document.getElementById(id).getContext('2d')

    new Chart(ctx, {
      type: 'doughnut',
      data: {
        datasets: [
          {
            data: [bluePercent, grayPercent],
            backgroundColor: [color, '#C7CDE0'],
            borderWidth: 0
          },
        ],
      },
      options: {
        rotation: 1 * Math.PI,
        circumference: 1 * Math.PI,
        tooltips: {
          enabled: false,
        },
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
          },
        },
        responsive: true,
        legend: {
          display: false,
          position: 'top',
        },
        title: {
          display: false,
          text: title,
        },
        cutoutPercentage: 85,
      },
    });
  }

  return (
    <div className={`bg-white border border-gray-275 rounded-lg px-6 ${classes}`}>
      <div className={`flex flex-col items-center relative ${graphClasses}`}>
        <div className='text-3xl text-gray-900 font-bold absolute' style={{ bottom: '3.9rem'}}>{percentage}%</div>
        <div className={`text-xs text-gray-500 absolute ${linerStyles}`}>{liner}</div>
        <div className='myChartDiv relative'>
          <canvas id={id} width='200' height='200'></canvas>
          <div className='absolute bottom-6 w-52 flex justify-between text-xs text-gray-500'>
            <span>0%</span>
            <span>100%</span>
          </div>
        </div>
      </div>
      {metricValue && <div className='text-center text-gray-500 text-sm font-medium mb-5'>{metricValue}</div>}
    </div>
  )
}

export default SemiDonughnutGraph
